<template>
  <a-modal width="900px" title="详情" :footer="null" :destroyOnClose="true" :keyboard="true" v-model="visible">
    <a-row>
      <a-col v-for="item in labels" :key="item.key" :span="12">
        <div class="form-item">
          <label>{{ item.laebl }}:</label>
          <a-input :readOnly="true" :value="form[item.key]" />
        </div>
      </a-col>
    </a-row>
    <div class="form-item">
      <label style="width:105px" v-if="isReview">回复内容:</label>
      <label v-else style="width:105px">评论内容：</label>
      <a-textarea :readOnly="true" :value="form.content" :rows="4" />
      <a-button @click="checkFail('content')" class="btn-color-warning" style="margin-left:10px" type="primary">敏感词检测</a-button>
    </div>
    <div style="width: 100%;padding: 0 80px" v-if="warnContent.status" v-html="warnContent.content"></div>
    <div class="form-item" v-if="isReview">
      <label style="width:105px">回复的内容:</label>
      <a-textarea :readOnly="true" :value="form.parentComment.content" :rows="4" />
      <div style="width:120px;margin-left:20px"></div>
    </div>
  </a-modal>
</template>

<script>
import { forbiddenWordsArticle } from '@/api/article/list.js'
import { mapState } from "vuex"
import $moment from "moment"
import { commentDetail } from '@/api/groupWeb/article'
import { formLabels, replyLabels } from "../business/index"
export default {
  computed: {
    ...mapState(['label'])
  },
  watch: {
    isReview: {
      handler(val) {
        this.labels = val ? replyLabels : formLabels
      },
      immediate: true
    },
    visible: {
      handler(val) {
        if (!val) {
          this.warnContent = {
            status: false,
            content: ''
          }
        }
      }
    }
  },
  data() {
    return {
      warnContent: {
        status: false,
        content: ''
      },
      visible: false,
      form: {
        parentComment: {}
      },
      wrapperCol: {},
      labelCol: { span: 10, offset: 0 },
      labels: [],
      isReview: false,
    }
  },
  methods: {
    async checkFail(key) {
      if (!this.form[key]) {
        this.warnContent.status = false
        this.$message.warning('无评论内容')
        return
      }
      const params = {
        content: this.form[key],
      }
      const { data } = await forbiddenWordsArticle(params)
      if (data.content.indexOf('color:#F00') === -1) {
        this.warnContent.status = false
        this.$message.success('无违禁词')
      } else {
        this.warnContent.status = true
        this.warnContent.content = data.content
        this.$message.warning('存在为违禁词')
      }
    },
    textFormat(text, key) {
      return this.label.data?.POSTS?.[key].find((d) => d.key === Number(text))?.value
    },
    async open(id, type) {
      this.isReview = type === 'review'
      const { data } = await commentDetail(id)
      const { created_number, created_name, approval_number, approval_name, approva_at, created_at } = data
      data.created_user = Number(created_number) ? `${created_name}(${created_number})` : '--'
      data.approval_user = Number(approval_number) ? `${approval_name}(${approval_number})` : '--'
      data.approva_at = Number(approva_at) ? $moment.unix(approva_at).format('YYYY-MM-DD HH:mm:SS') : '--'
      data.created_at = Number(created_at) ? $moment.unix(created_at).format('YYYY-MM-DD HH:mm:SS') : '--'
      data.is_del = this.textFormat(data.is_del, 'DEL')
      data.approva_status = this.textFormat(data.approva_status, 'CHECK_STATUS')
      this.form = data
      this.visible = true
    },
  },
}
</script>

<style lang="less" scoped>
.form-item{
  display: flex;
  padding-right: 10px;
  margin-bottom: 16px;
  & > label {
    width: 120px;
    height: 32px;
    line-height: 32px;
  }
}
</style>
